import { notification } from '../../../api';
import { call, takeLatest, put, delay } from 'redux-saga/effects';
import {
  FETCH_NOTIFICATIONS,
  FETCH_NOTIFICATIONS_START,
  FETCH_NOTIFICATIONS_COMPLETE,
  FETCH_NOTIFICATIONS_ERROR,
  MARK_NOTIFICATION_READ,
  MARK_NOTIFICATION_READ_START,
  MARK_NOTIFICATION_READ_COMPLETE,
  MARK_NOTIFICATION_READ_ERROR,
  MARK_ALL_NOTIFICATIONS_READ,
  MARK_ALL_NOTIFICATIONS_READ_START,
  MARK_ALL_NOTIFICATIONS_READ_COMPLETE,
  MARK_ALL_NOTIFICATIONS_READ_ERROR,
  FETCH_NOTIFICATION_COUNT,
  FETCH_NOTIFICATION_COUNT_START,
  FETCH_NOTIFICATION_COUNT_COMPLETE,
  FETCH_NOTIFICATION_COUNT_ERROR,
} from './actions';
import errorStrings from '../../../constants/errorStrings';
import { setUserStatusUnauthorised } from '../userProfile/actions';

export function* fetchNotificationsSaga({ payload: { params } }) {
  try {
    yield put({
      type: FETCH_NOTIFICATIONS_START,
    });
    
    // Mock delay to simulate API call
    yield delay(500);
    
    // Mock notifications data
    const mockNotifications = [
      {
        id: 'NOTIF-1',
        message: 'Payment Due',
        description: 'Your monthly payment is due on 20 Jan',
        date: new Date(Date.now() - 5 * 60 * 1000).toISOString(), // 5 minutes ago
        isRead: false,
      },
      {
        id: 'NOTIF-2',
        message: 'New Feature Released',
        description: 'Dark mode is now available',
        date: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(), // 2 hours ago
        isRead: true,
      },
      {
        id: 'NOTIF-3',
        message: 'Shift Reminder',
        description: 'Your shift starts in 2 hours. Please confirm your attendance.',
        date: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(), // 1 day ago
        isRead: false,
      },
      {
        id: 'NOTIF-4',
        message: 'Achievement Unlocked',
        description: 'Congratulations! You have completed 100 shifts this month.',
        date: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(), // 3 days ago
        isRead: false,
      },
      {
        id: 'NOTIF-5',
        message: 'Profile Update Required',
        description: 'Please update your profile information to continue using the platform.',
        date: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(), // 7 days ago
        isRead: true,
      },
      {
        id: 'NOTIF-6',
        message: 'Weekly Report Available',
        description: 'Your weekly performance report is now available for review.',
        date: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString(), // 10 days ago
        isRead: true,
      },
    ];

    // Filter by unreadOnly if specified
    let filteredNotifications = mockNotifications;
    if (params?.unreadOnly) {
      filteredNotifications = mockNotifications.filter((n) => !n.isRead);
    }

    // Simulate pagination
    const pageNumber = params?.pageNumber || 1;
    const pageSize = params?.pageSize || 50;
    const startIndex = (pageNumber - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    const paginatedNotifications = filteredNotifications.slice(startIndex, endIndex);

    yield put({
      type: FETCH_NOTIFICATIONS_COMPLETE,
      payload: {
        data: paginatedNotifications,
        count: filteredNotifications.length,
      },
    });

    // Uncomment below to use actual API call instead of mock data
    // const { response, error } = yield call(notification.fetchNotifications, {
    //   params: params || { pageNumber: 1, pageSize: 50, unreadOnly: false },
    // });
    // if (!!response) {
    //   yield put({
    //     type: FETCH_NOTIFICATIONS_COMPLETE,
    //     payload: {
    //       data: response.notifications || response.data || [],
    //       count: response.count || 0,
    //     },
    //   });
    // } else {
    //   if (error.status === 401) {
    //     yield put(setUserStatusUnauthorised());
    //   } else {
    //     yield put(
    //       onFetchNotificationsError({
    //         error: error?.data?.message
    //           ? error?.data.message
    //           : errorStrings.commonError,
    //       }),
    //     );
    //   }
    // }
  } catch (error) {
    yield put(
      onFetchNotificationsError({
        error: errorStrings.commonError,
      }),
    );
  }
}

export function* markNotificationAsReadSaga({ payload: { params, successCallback } }) {
  try {
    yield put({
      type: MARK_NOTIFICATION_READ_START,
    });
    
    // Mock delay to simulate API call
    yield delay(300);
    
    // Mock successful response
    yield put({
      type: MARK_NOTIFICATION_READ_COMPLETE,
      payload: {
        notificationId: params?.id,
      },
    });
    
    if (successCallback) {
      yield call(successCallback);
    }

    // Uncomment below to use actual API call instead of mock data
    // const { response, error } = yield call(notification.markNotificationAsRead, {
    //   params,
    // });
    // if (!!response) {
    //   yield put({
    //     type: MARK_NOTIFICATION_READ_COMPLETE,
    //     payload: {
    //       notificationId: params?.id,
    //     },
    //   });
    //   if (successCallback) {
    //     yield call(successCallback);
    //   }
    // } else {
    //   if (error.status === 401) {
    //     yield put(setUserStatusUnauthorised());
    //   } else {
    //     yield put(
    //       onMarkNotificationReadError({
    //         error: error?.data?.message
    //           ? error?.data.message
    //           : errorStrings.commonError,
    //       }),
    //     );
    //   }
    // }
  } catch (error) {
    yield put(
      onMarkNotificationReadError({
        error: errorStrings.commonError,
      }),
    );
  }
}

export function* markAllNotificationsAsReadSaga({ payload: { successCallback } }) {
  try {
    yield put({
      type: MARK_ALL_NOTIFICATIONS_READ_START,
    });
    
    // Mock delay to simulate API call
    yield delay(300);
    
    // Mock successful response
    yield put({
      type: MARK_ALL_NOTIFICATIONS_READ_COMPLETE,
    });
    
    if (successCallback) {
      yield call(successCallback);
    }

    // Uncomment below to use actual API call instead of mock data
    // const { response, error } = yield call(notification.markAllNotificationsAsRead);
    // if (!!response) {
    //   yield put({
    //     type: MARK_ALL_NOTIFICATIONS_READ_COMPLETE,
    //   });
    //   if (successCallback) {
    //     yield call(successCallback);
    //   }
    // } else {
    //   if (error.status === 401) {
    //     yield put(setUserStatusUnauthorised());
    //   } else {
    //     yield put(
    //       onMarkAllNotificationsReadError({
    //         error: error?.data?.message
    //           ? error?.data.message
    //           : errorStrings.commonError,
    //       }),
    //     );
    //   }
    // }
  } catch (error) {
    yield put(
      onMarkAllNotificationsReadError({
        error: errorStrings.commonError,
      }),
    );
  }
}

export function* fetchNotificationCountSaga() {
  try {
    yield put({
      type: FETCH_NOTIFICATION_COUNT_START,
    });
    
    // Mock delay to simulate API call
    yield delay(300);
    
    // Mock unread count (3 unread notifications from mock data)
    yield put({
      type: FETCH_NOTIFICATION_COUNT_COMPLETE,
      payload: {
        unreadCount: 3,
      },
    });

    // Uncomment below to use actual API call instead of mock data
    // const { response, error } = yield call(notification.getNotificationCount);
    // if (!!response) {
    //   yield put({
    //     type: FETCH_NOTIFICATION_COUNT_COMPLETE,
    //     payload: {
    //       unreadCount: response.unreadCount || 0,
    //     },
    //   });
    // } else {
    //   if (error.status === 401) {
    //     yield put(setUserStatusUnauthorised());
    //   } else {
    //     yield put(
    //       onFetchNotificationCountError({
    //         error: error?.data?.message
    //           ? error?.data.message
    //           : errorStrings.commonError,
    //       }),
    //     );
    //   }
    // }
  } catch (error) {
    yield put(
      onFetchNotificationCountError({
        error: errorStrings.commonError,
      }),
    );
  }
}

const onFetchNotificationsError = (payload = {}) => ({
  type: FETCH_NOTIFICATIONS_ERROR,
  payload,
});

const onMarkNotificationReadError = (payload = {}) => ({
  type: MARK_NOTIFICATION_READ_ERROR,
  payload,
});

const onMarkAllNotificationsReadError = (payload = {}) => ({
  type: MARK_ALL_NOTIFICATIONS_READ_ERROR,
  payload,
});

const onFetchNotificationCountError = (payload = {}) => ({
  type: FETCH_NOTIFICATION_COUNT_ERROR,
  payload,
});

function* watchFetchNotifications() {
  yield takeLatest(FETCH_NOTIFICATIONS, fetchNotificationsSaga);
}

function* watchMarkNotificationAsRead() {
  yield takeLatest(MARK_NOTIFICATION_READ, markNotificationAsReadSaga);
}

function* watchMarkAllNotificationsAsRead() {
  yield takeLatest(MARK_ALL_NOTIFICATIONS_READ, markAllNotificationsAsReadSaga);
}

function* watchFetchNotificationCount() {
  yield takeLatest(FETCH_NOTIFICATION_COUNT, fetchNotificationCountSaga);
}

export const sagas = [
  watchFetchNotifications,
  watchMarkNotificationAsRead,
  watchMarkAllNotificationsAsRead,
  watchFetchNotificationCount,
];

